<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Lista maszyn</h3>
            <div class="d-flex flex-row gap-3">
                    <!-- Filter serial number -->
                <mat-form-field appearance="outline">
                    <mat-label style="color: gray;">Szukaj...</mat-label>
                    <input matInput [formControl]="filter" (blur)="saveFilter()">
                </mat-form-field>

                    <!-- Filter status -->
                <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select [formControl]="selectedStatus" multiple (selectionChange)="saveStatus()">
                        <mat-option value="1">OK</mat-option>
                        <mat-option value="0">ERROR</mat-option>
                        <mat-option value="2">OFFLINE</mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Filter tag -->
                <mat-form-field appearance="outline" *ngIf="userPermission != 0">
                    <mat-label>Etykieta</mat-label>
                    <input matInput [formControl]="selectedOrganization" [matAutocomplete]="autoOrg" (blur)="saveOrg()">
                    <mat-autocomplete #autoOrg="matAutocomplete" >
                        @for (name of filteredOrganizationNames$ | async; track name ) {
                            <mat-option (onSelectionChange)="doFilterTag(name)" [value]="name">{{name}}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="d-flex flex-row gap-3 justify-content-end">
                <button mat-flat-button class="big-button" color="accent" (click)="router.navigate(['rekbot-add'])"  *ngIf="userPermission >= 80">
                    <mat-icon class="big-icon">add</mat-icon> Dodaj Rekbota</button>
                <button mat-flat-button class="big-button" color="accent"
                    (click)="onMapOpen()">Pokaż mapę Rekbotów</button>
                <button mat-flat-button class="big-button" color="accent" (click)="fetchRekbots()">
                    <mat-icon class="big-icon m-0">refresh</mat-icon>
                </button>
                <br>
            </div>

            
                
            

            <div class="d-flex flex-row align-items-center p-2 gap-3 w-100">
                <button mat-flat-button (click)="onToggleSelect()" *ngIf="!selectMode && userPermission >= 80">Wybierz Rekboty</button>
                <ng-content *ngIf="selectMode && userPermission >= 80">
                    <button mat-flat-button (click)="onProdStatusSubmit()">Zatwierdź</button>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="setProdStatus($event.value)">
                        <!-- <mat-button-toggle [value]="-1">Żaden</mat-button-toggle> -->
                        <mat-button-toggle [value]="2" *ngIf="selectedRekbots != 0">Klient</mat-button-toggle>
                        <mat-button-toggle [value]="1" *ngIf="selectedRekbots != 1">Montaż</mat-button-toggle>
                        <mat-button-toggle [value]="0" *ngIf="selectedRekbots != 2">Magazyn</mat-button-toggle>
                    </mat-button-toggle-group>
                    <button mat-flat-button (click)="onCancelProdStatus()">Anuluj</button>
                </ng-content>
                
                
                <button mat-flat-button (click)="clearFilters()" class="ms-auto">Wyczyść filtry</button>
                <!-- <mat-icon [ngClass]="{'text-primary': viewTiles == true}" (click)="viewTiles = true">widgets</mat-icon>
                <mat-icon [ngClass]="{'text-primary': viewTiles == false}" (click)="viewTiles = false">storage</mat-icon> -->
            </div>
    </div>
    <div class="w-100 d-flex justify-content-center" *ngIf="isLoading"><mat-spinner ></mat-spinner></div>
    

    <mat-tab-group [selectedIndex]="selectedRekbots" (selectedTabChange)="onTabChange($event)" *ngIf="!isLoading && !errorMessage">
        <mat-tab label="Klient"> 
            <!-- <app-table-rekbot-list [rekbots$]="filteredRekbots$"  *ngIf="!viewTiles" class="w-100"></app-table-rekbot-list> -->
            <app-table-rekbot-list 
            [rekbots$]="customerRekbots$"  
            *ngIf="!viewTiles" class="w-100" 
            [label]="labels[0]" 
            [selectMode]="childrenState[0]"
            (onChangeState)="handleChangeState($event)"></app-table-rekbot-list>
        </mat-tab>
        <mat-tab label="Montaż" *ngIf="userPermission >= 80 ">
            <app-table-rekbot-list 
            [rekbots$]="installationRekbots$"  
            *ngIf="!viewTiles" class="w-100"  
            [label]="labels[1]" 
            [selectMode]="childrenState[1]"
            (onChangeState)="handleChangeState($event)"></app-table-rekbot-list>
        </mat-tab>
        <mat-tab label="Magazyn" *ngIf="userPermission >= 80 ">
            <app-table-rekbot-list 
            [rekbots$]="warehouseRekbots$"  
            *ngIf="!viewTiles" class="w-100"  
            [label]="labels[2]" 
            [selectMode]="childrenState[2]"
            (onChangeState)="handleChangeState($event)"></app-table-rekbot-list>
        </mat-tab>
    </mat-tab-group>

    <h3 class="w-100 d-flex justify-content-center" *ngIf="!isLoading && errorMessage"> {{errorMessage}}</h3>
</div>